import { ReactNode } from 'react';
import { cx } from './cx';

export interface TooltipProps {
  label: string;
  children: ReactNode;
  className?: string;
}

const Tooltip = ({ label, children, className }: TooltipProps) => (
  <span className={cx('relative inline-flex group/tooltip', className)}>
    {children}
    <span
      role="tooltip"
      className="pointer-events-none absolute bottom-full left-1/2 z-50 mb-1.5 -translate-x-1/2 whitespace-nowrap rounded-md bg-meradio-dark px-2 py-1 text-xs text-white opacity-0 shadow-lg transition-opacity duration-150 group-hover/tooltip:opacity-100 group-focus-within/tooltip:opacity-100 dark:bg-neutral-800"
    >
      {label}
    </span>
  </span>
);

export default Tooltip;
